import { useEffect, useRef } from 'react';
import { MultiStepModalProps } from '../interface/interface';
import { CloseIcon } from '../assets/svgImages';

const MultiStepModal = ({
  headerText,
  steps,
  visible,
  onClose,
  modalSize,
  selecteToken,
  substituteToken,
  step,
  handleNext,
  handlePrev,
  handleSubmit,
}: MultiStepModalProps) => {
  const multiModalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (visible) {
      step.setter(0);
    }
  }, [visible]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        multiModalRef.current &&
        !multiModalRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (visible) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-gray-800 opacity-75"></div>
      <div
        ref={multiModalRef}
        className={`relative bg-grey-50 rounded-lg shadow-lg px-3.5 lg:px-7 py-2.5 lg:py-5 w-1/2 ${modalSize}`}
      >
        <div className="flex justify-between items-center">
          <h3 className="text-2xl font-semibold text-primary-blue-500">
            {headerText}
          </h3>
          <CloseIcon onClick={onClose} className="cursor-pointer fill-primary-blue-500" />
        </div>
        <div className="my-10">{steps[step.state]}</div>
        <div className="flex items-center justify-center ">
          {step.state > 0 && (
            <button
              onClick={handlePrev}
              className="bg-transparent text-primary-blue-500 border border-primary-blue-500 text-base px-6 py-3 rounded mr-2"
            >
              Back
            </button>
          )}
          {step.state < steps.length - 1 ? (
            <button
              onClick={handleNext}
              className={`bg-primary-blue-500 text-white border border-primary-blue-500 text-base
                 px-6 py-3 rounded ${!selecteToken ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={!selecteToken}
            >
              Next
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              className={`bg-primary-blue-500 text-white border border-primary-blue-500 
                text-base px-6 py-3 rounded ${!substituteToken ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={!substituteToken}
            >
              Finish
            </button>
          )}
          {/* {footerButtons} */}
        </div>
      </div>
    </div>
  );
};

export default MultiStepModal;
